/**
 * TtfCmapSubTable.ts class for EJ2-PDF
 */
var TtfCmapSubTable = /** @class */ (function () {
    function TtfCmapSubTable() {
    }
    return TtfCmapSubTable;
}());
export { TtfCmapSubTable };
